export const dashboard = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'surface',

  Sidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    padding: 'B C',
    gap: 'B',
    overflow: 'auto',
    '@tabletS': { padding: 'A B' },
    '@mobileL': { padding: 'A' },

    TopHeader: {
      flow: 'x',
      align: 'center space-between',
      '@mobileL': { flow: 'y', gap: 'A' },
      GreetingText: {
        tag: 'h1',
        fontSize: 'C',
        fontWeight: '800',
        color: 'text',
        text: '{{ dashGreeting | polyglot }}',
        '@mobileL': { fontSize: 'B' },
      },
      HeaderRight: {
        flow: 'x', gap: 'A', align: 'center',
        '@mobileL': { flexWrap: 'wrap' },
        DateText: { text: '{{ dashDate | polyglot }}', fontSize: 'A', color: 'textSoft' },
        ThemeToggle: {},
      },
    },

    AlertBanner: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Z A',
      background: 'amberBg',
      border: '1px solid amberBorder',
      borderRadius: 'Z',
      show: (el, s) => !s.root.alertDismissed,
      AlertIcon: { extends: 'Icon', icon: 'warning', width: 'A', height: 'A', color: 'amber' },
      AlertText: { text: '{{ dashAlertText | polyglot }}', fontSize: 'Z', color: 'amber', fontWeight: '500', flex: '1', padding: '0 A' },
      DismissBtn: { extends: 'Button', text: '✕', theme: 'transparent', color: 'amber', fontSize: 'Z', padding: 'Y', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ alertDismissed: true }) },
    },

    StatsRow: {
      flow: 'x',
      gap: 'A',
      flexWrap: 'wrap',
      Stat1: { extends: 'StatCard', StatValue: { text: '14' }, StatLabel: { text: '{{ casesTitle | polyglot }}' } },
      Stat2: { extends: 'StatCard', StatValue: { text: '3' }, StatLabel: { text: '{{ dashTodayBookings | polyglot }}' } },
      Stat3: { extends: 'StatCard', StatValue: { text: '₾1,840', color: 'amber' }, StatLabel: { text: '{{ dashUnpaid | polyglot }}' } },
      Stat4: { extends: 'StatCard', StatValue: { text: '2', color: 'red' }, StatLabel: { text: '{{ dashOverdue | polyglot }}' } },
      Stat5: { extends: 'StatCard', StatValue: { text: '23' }, StatLabel: { text: '{{ dashAiGenerations | polyglot }}' } },
    },

    ContentColumns: {
      flow: 'x',
      gap: 'B',
      flexWrap: 'wrap',
      '@tabletS': { flow: 'y' },

      BookingsCol: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        minWidth: 'F',
        ColTitle: { tag: 'h2', text: '{{ dashTodaysBookings | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },

        Booking1: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          BookingInfo: {
            flow: 'y',
            gap: 'Z',
            ClientName: { text: '{{ clientName1 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            BookingTime: { text: '{{ dashBooking1Time | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          BookingChip: { extends: 'StatusConfirmed', text: '{{ dashConfirmed | polyglot }}' },
        },
        Booking2: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          BookingInfo: {
            flow: 'y',
            gap: 'Z',
            ClientName: { text: '{{ clientName2 | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            BookingTime: { text: '{{ dashBooking2Time | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          BookingChip: { extends: 'StatusPending', text: '{{ pendingTab | polyglot }}' },
        },
        Booking3: {
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          BookingInfo: {
            flow: 'y',
            gap: 'Z',
            ClientName: { text: '{{ dashClient3Name | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            BookingTime: { text: '{{ dashBooking3Time | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          BookingChip: { extends: 'StatusConfirmed', text: '{{ dashConfirmed | polyglot }}' },
        },
      },

      CasesCol: {
        flow: 'y',
        gap: 'A',
        flex: '1',
        minWidth: 'F',
        ColTitle: { tag: 'h2', text: '{{ dashRecentCases | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'text' },

        Case1: {
          extends: 'Link',
          href: '/cases',
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          textDecoration: 'none',
          onClick: (e, el, s) => s.root.update({ activeCaseId: 1 }),
          CaseInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNum: { text: '{{ caseRow1Title | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            CaseMeta: { text: '{{ dashCaseMeta1 | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          CaseChip: { extends: 'StatusActive', text: '{{ activeTab | polyglot }}' },
        },
        Case2: {
          extends: 'Link',
          href: '/cases',
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          textDecoration: 'none',
          onClick: (e, el, s) => s.root.update({ activeCaseId: 2 }),
          CaseInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNum: { text: '{{ caseRow2Title | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            CaseMeta: { text: '{{ dashCaseMeta2 | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          CaseChip: { extends: 'StatusPending', text: '{{ pendingTab | polyglot }}' },
        },
        Case3: {
          extends: 'Link',
          href: '/cases',
          flow: 'x',
          align: 'center space-between',
          padding: 'A',
          background: 'surfaceBorder',
          border: '1px solid surfaceBorderStrong',
          borderRadius: 'Z',
          textDecoration: 'none',
          onClick: (e, el, s) => s.root.update({ activeCaseId: 3 }),
          CaseInfo: {
            flow: 'y',
            gap: 'Z',
            CaseNum: { text: '{{ caseRow3Title | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'text' },
            CaseMeta: { text: '{{ dashCaseMeta3 | polyglot }}', fontSize: 'Z', color: 'textSoft' },
          },
          CaseChip: { extends: 'StatusClosed', text: '{{ closedTab | polyglot }}' },
        },
      },
    },

    QuickActions: {
      flow: 'x',
      gap: 'A',
      padding: 'A 0',
      flexWrap: 'wrap',
      Action1: { extends: 'QuickActionBtn', href: '/bookings', ActionIcon: { icon: 'plus' }, ActionText: { text: '{{ dashNewBooking | polyglot }}' } },
      Action2: { extends: 'QuickActionBtn', href: '/cases', ActionIcon: { icon: 'plus' }, ActionText: { text: '{{ dashNewCase | polyglot }}' } },
      Action3: { extends: 'QuickActionBtn', href: '/documents', ActionIcon: { icon: 'ai' }, ActionText: { text: '{{ dashAiDocument | polyglot }}' } },
    },
  },
}
